import Structure from "./Structure";
import { useState } from 'react';

const structures = {
  1:[[["A"]]],
  2:[[["A","B"]],[["A"],["B"]]],
  3:[[["A","B","C"]],[["A"],["B"],["C"]]],
  4:[
    [["A","B","C","D"]],
    [["A"],["B"],["C"],["D"]],
    [["A","B"],["C","D"]]
    ],
  5:[
    [["A","B","C","D","E"]],
    [["A"],["B"],["C"],["D"],["E"]],
    ],
  6:[
    [["A","B","C","D","E","F"]]
    ],
}

export default function StructureOptions({
  numBlocks=4,
  value,
  templateDispatch,

}){

  const [structure,s] = useState(value);
  const [b,sb] = useState(numBlocks);


  let structureList = structures[b];

  let structs = structureList.map((ss,ii) => {

    let isSelected = (
      JSON.stringify(ss)
      ===
      JSON.stringify(value)
    )


    return (<div onClick={() => {
      templateDispatch({channelGroupStructure:ss})
    }} class="sg-row v-center h-center hoverable" style={{
      padding:5,
      background:(isSelected && '#ccc'),
      minWidth:40,
      height:40,
      borderRadius:5,
    }}>
      <Structure interactive={false} size={8} structure={ss}/>
    </div>
    )
  })

  

  return (
    <div style={{
      //position:'absolute', 
      pointerEvents:'auto',
      }} 
      class="sg-row v-center">


      <input 
        spinner={"n-channel-slots"}
        style={{width:40,
        marginRight:10,
        fontSize:18
        }}
        onChange={e => {
          let newValue = (e.target.value)

          sb(Number(newValue))
          templateDispatch({
            channelGroupStructure:structures[newValue][0]
          })
        }}
        min={1}
        max={6}
            value={b}
          type="number"/>

      {structs}




    </div>
  )


}
